// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f61c3033","453":"1af793ad","455":"ae07ab67","977":"8516f8f7"}[chunkId] + ".chunk.js";
};